import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse, ValueIdPair } from '../../../_services/app.service';
import { ContributeTransactionalComponent, Transaction } from '../contribute-transactional.component';
import moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'D MMM YYYY',
  },
  display: {
    dateInput: 'D MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-add-trade',
    templateUrl: './add-trade.component.html',
    styleUrls: ['./add-trade.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [
                MAT_DATE_LOCALE,
                MAT_MOMENT_DATE_ADAPTER_OPTIONS
            ]
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        },
    ],
    standalone: false
})

export class AddTradeComponent implements OnInit {
  isUpdateTrans: boolean = false;
  transaction: Transaction;
  listItems: ListItems;
  marketId: string = '';
  isNew: boolean = true;

  constructor(private translate: TranslateService, @Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private service: AppService, public dialogRef: MatDialogRef<ContributeTransactionalComponent>) {
  }

  public ngOnInit(): void {
    this.listItems = {
      cpSectorList: [],
      currencyList: [],
      instrumentTypeList: [],
      statusList: [],
      typeList: []
    };
    this.marketId = this.data.marketId;
    this.getListItems();
    if (this.data.trade) {
      this.isUpdateTrans = true;
      this.data.trade.tradeDate = moment(this.data.trade.tradeDate).format('YYYY-MM-DD');
      this.data.trade.maturityDate = moment(this.data.trade.maturityDate).format('YYYY-MM-DD');
      this.data.trade.settlementDate = moment(this.data.trade.settlementDate).format('YYYY-MM-DD');
      this.transaction = {
        state: this.data.trade.state,
        stateColor: this.data.trade.stateColor,
        id: this.data.trade.id,
        contributed: this.data.trade.contributed,
        identifier: this.data.trade.identifier,
        counterParty: this.data.trade.counterParty,
        currency: this.data.trade.currency,
        status: this.data.trade.status,
        type: this.data.trade.type,
        maturityDate: this.data.trade.maturityDate,
        settlementDate: this.data.trade.settlementDate,
        tradeDate: this.data.trade.tradeDate,
        nominalAmount: this.data.trade.nominalAmount,
        rate: this.data.trade.rate,
        hasUpdated: this.data.trade.hasUpdated,
        instrumentType: this.data.trade.instrumentType,
        comments: this.data.trade.comments,
        notes: this.data.trade.notes,
        changedProps: this.data.trade.changedProps
      };
    } else {
      this.transaction = {
        state: '',
        stateColor: '',
        id: '',
        contributed: '',
        identifier: '',
        counterParty: '',
        currency: { id: '', value: '' },
        status: 'New',
        type: '',
        instrumentType: '',
        maturityDate: '',
        settlementDate: '',
        tradeDate: '',
        nominalAmount: 0,
        rate: '',
        hasUpdated: true,
        comments: '',
        notes: '',
        changedProps: []
      };
    }

    // Set the status.
    if (this.transaction.contributed) {
      this.isNew = false;
    }
  }

  private getListItems(): void {
    if (this.marketId) {
      this.service.showSpinner();
      this.http.get<ListItems>(this.baseUrl + 'api/contribute/getTransactionLists/' + this.marketId).subscribe(result => {
        this.listItems = result;
      }, error => {
        console.error(error);
      }, () => {
        this.service.hideSpinner();
      });
    }
  }

  /**
   * Saves the transaction when the OK button is clicked.
   */
  public onSaveTransaction(): void {
    this.transaction.tradeDate = moment(this.transaction.tradeDate).format('YYYY-MM-DD');
    this.transaction.maturityDate = moment(this.transaction.maturityDate).format('YYYY-MM-DD');
    this.transaction.settlementDate = moment(this.transaction.settlementDate).format('YYYY-MM-DD');
    if (this.hasChanges() === true) {
      this.http.post<TransactionValidateResponse>(`${this.baseUrl}api/contribute/validateTransaction/${this.marketId}`, this.transaction).subscribe(result => {

        if (result.response.statusCode == 1) {
          this.transaction = result.transaction;

          // Updates the currency
          this.transaction.currency = this.listItems.currencyList.find(e => e.id == this.transaction.currency.id);
          this.dialogRef.close(this.transaction);
        } else {
          this.service.SaveStatus(false, (this.isUpdateTrans ? 'Contribute.lblEditTransaction' : 'Contribute.lblNewTransaction'), result.response.statusMessage)
        }
      }, error => {
        console.error(error);
      });
    }
  }

  /**
   * Cancel button event
   */
  public onCancel(): void {
    this.dialogRef.close(null);
  }

  /**
   * Determines whether any items that make up a transaction have changed.
   * @returns Boolean indicating whether changes have been name
   */
  public hasChanges(): boolean {
    let changed: boolean = true;
    if (this.isUpdateTrans === true) {
      changed = false;
      if (this.transaction.counterParty != this.data.trade.counterParty) {
        changed = true;
      }
      if (this.listItems.currencyList.findIndex(currency => currency.id == this.transaction.currency.id && currency.value == this.transaction.currency.value) == -1) {
        changed = true;
      }
      if (this.transaction.type != this.data.trade.type) {
        changed = true;
      }
      if (this.transaction.maturityDate != this.data.trade.maturityDate) {
        changed = true;
      }
      if (this.transaction.settlementDate != this.data.trade.settlementDate) {
        changed = true;
      }
      if (this.transaction.tradeDate != this.data.trade.tradeDate) {
        changed = true;
      }
      if (this.transaction.nominalAmount != this.data.trade.nominalAmount) {
        changed = true;
      }
      if (this.transaction.rate != this.data.trade.rate) {
        changed = true;
      }
      if (this.transaction.instrumentType != this.data.trade.instrumentType) {
        changed = true;
      }
    }
    return changed;
  }
}

interface ListItems {
  cpSectorList: string[],
  instrumentTypeList: string[],
  typeList: string[],
  statusList: string[],
  currencyList: ValueIdPair[]
}

interface TransactionValidateResponse {
  response: GRSSResponse,
  transaction: Transaction
}
